/* eslint-disable */

const validate = (email: string) => {
  let error: string = ''

  if (!email) {
    error = 'email is required'
    return error
  } else if (
    !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(
      email
    )
  ) {
    error = 'email is invalid'
    return error
  }

  return error
}

export default validate
